var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-bar"},[_c('div',{staticClass:"info"},[_c('h3',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),(_vm.subTitle)?_c('p',{staticClass:"sub-title"},[_vm._v(_vm._s(_vm.subTitle))]):_vm._e()]),(_vm.needMore)?_c('div',{staticClass:"more",on:{"click":_vm.handleClick}},[_vm._v("More")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }